import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  roundBig: {
    minWidth: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#EA2075',
    textAlign: 'center',
    '& svg': {
      color: 'white',
      marginTop: '8px',
    },
  },
  icon: {
    color: 'white',
    marginTop: '8px',
  },
  roundSmall: {
    minWidth: '33px',
    height: '33px',
    borderRadius: '50%',
    textAlign: 'center',
    '& svg': {
      color: 'white',
      marginTop: '5px',
      width: '20px',
    },
  },
  roundSmallPink: {
    backgroundColor: '#EA2075',
  },
  roundSmallBlue: {
    backgroundColor: '#3560FF',
  },
  roundSmallBlueHistory: {
    alignSelf: 'flex-start',
    marginTop: '15px',
    backgroundColor: '#3560FF',
  },
  expand: {
    display: 'flex',
    cursor: 'pointer',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  expandIcon: {
    marginTop: '4px',
  },
  list: { width: '100%', maxHeight: '150px', overflow: 'auto', borderTop: '1px solid rgba(44, 45, 62, 0.3)' },
  listHistory: { width: '100%', maxHeight: 'auto', overflow: 'none' },
  listItem: {
    border: '1px solid rgba(44, 45, 62, 0.3)',
    borderRadius: '4px',
    width: '100%',
    padding: '5px',
    paddingLeft: '10px',
    paddingBottom: '10px',
    marginLeft: '5px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif1',
    fontSize: '14px',
    color: '#2C2D3E',
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiInput-underline:before': {
      borderBottom: 'solid 1px white',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'solid 1px white',
    },
    '& .MuiInput-underline:hover': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'solid 1px white',
    },
  },
  listItemHistory: {
    border: 'none',
    width: '100%',
    paddingBottom: '0',
    marginLeft: '5px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif1',
    fontSize: '14px',
    color: '#2C2D3E',
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiInput-underline:before': {
      borderBottom: 'solid 1px white',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'solid 1px white',
    },
    '& .MuiInput-underline:hover': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'solid 1px white',
    },
  },
  listItemTextHistory: {
    width: '99%',
    border: '1px solid rgba(44, 45, 62, 0.3)',
    padding: '5px',
    borderRadius: '4px',
    '& .MuiInput-underline:before': {
      borderBottom: 'solid 1px white',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'solid 1px white',
    },
  },
  showHistoryContainer: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'end',
  },
  showHistoryText: {
    color: '#3560FF',
    textDecoration: 'underline',
    display: 'flex',
    alignItems: 'center',
    margin: '0px',
  },
  disabledAction: {
    position: 'absolute',
    top: '-7px',
    left: '-5px',
    height: '40%',
    width: '40%',
    fill: 'black',
    backgroundColor: 'white',
    borderRadius: '50%',
  },
}));
